var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getNewToken, tokenState } from './getNewToken';
const getNewAccessToken = (clientConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const { accessToken } = yield getNewToken(clientConfig);
    return accessToken;
});
const getAccessToken = (clientConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const { accessToken, expiryDate } = tokenState;
    const now = new Date();
    if (!accessToken || !expiryDate || expiryDate < now.getTime()) {
        return yield getNewAccessToken(clientConfig);
    }
    return accessToken;
});
const doFetch = (input, init, clientConfig, accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    const accessTokenValue = accessToken || (yield getNewAccessToken(clientConfig));
    const headers = Object.assign(Object.assign({}, init.headers), { Authorization: `Bearer ${accessTokenValue}` });
    return fetch(input, Object.assign(Object.assign({}, init), { headers }));
});
const fetchAuthorized = (input, init, clientConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const accessToken = yield getAccessToken(clientConfig);
    const response = yield doFetch(input, init, clientConfig, accessToken);
    if (response.status === 401) {
        return yield doFetch(input, init, clientConfig);
    }
    return response;
});
export { fetchAuthorized };
//# sourceMappingURL=fetchAuthorized.js.map